<template>
  <ErrorPage type="FORBIDDEN" :hat="message" />
</template>

<script setup lang="ts">
import { ErrorPage } from "@pasta/box-v2";

const message = `Vous avez essayé de vous connecter à un parapheur sur lequel vous n'avez pas les droits d'accès.
Pour accéder au parapheur, vous pouvez demander à un agent ayant accès au parapheur de vous ajouter en copie ou dans le flux.
L'équipe Parapheur`;
</script>
